import findIndex from 'lodash/findIndex'

export default {
  setLoading: (state, status) => (state.loading = status),
  setProfileList: (state, list) => (state.profileList = list),
  setProfileTypeList: (state, list) => (state.profileTypeList = list),
  setCurrentStep: (state, step) => (state.currentStep = step),
  setCreateTypeId: (state, id) => (state.createTypeId = id),
  setEditProfileId: (state, id) => (state.editProfileId = id),
  setProfileProps: (state, items) => (state.profileProps = items),
  setProfilePropValueByCode: (state, {code, value}) => {
    const props = state.profileProps
    const index = findIndex(props, e => e.code === code)
    props[index].value = value
    state.profileProps = [...props]
  },
  setProfileName: (state, value) => (state.profileName = value)
}



// WEBPACK FOOTER //
// ./src/components/store/modules/profile/mutations.js